import React from 'react';
import { Box, Card, CardContent, Avatar, Typography } from '@mui/material';
import { LockOutlined, InfoOutlined } from '@mui/icons-material';

const AccessDeniedBox = ({
  title = 'Acceso denegado',
  message = 'No tienes permisos para ver esta sección. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.',
  hint = 'Si crees que esto es un error, intenta recargar la página o vuelve a iniciar sesión. También puedes navegar a otras secciones desde el menú lateral.'
}) => {
  return (
    <Box sx={{ mt: 6, px: 2 }}>
      <Card sx={{
        maxWidth: 720,
        mx: 'auto',
        borderRadius: 3,
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        overflow: 'hidden'
      }}>
        <CardContent sx={{ p: 5, textAlign: 'center' }}>
          <Avatar sx={{ bgcolor: 'error.light', color: 'error.main', width: 72, height: 72, mx: 'auto', mb: 2 }}>
            <LockOutlined />
          </Avatar>
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            {message}
          </Typography>
          <Box sx={{ backgroundColor: '#f9fafb', border: '1px solid #eceff1', borderRadius: 2, p: 2, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
            <InfoOutlined color="primary" />
            <Box>
              <Typography variant="body2" color="text.secondary">
                {hint}
              </Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AccessDeniedBox;


